<!--Apply:申请试用 2021/03/08 17:23:21 Sunanguang-->

<template>
  <div class="apply-page">
    <iframe id="applyIframe" :src="url" width="100%" height="842" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  name: 'Apply',
  data() {
    return {
      url: ''
    }
  },
  mounted() {
    if (window.screen.width < 1000) {
      const url = '/official/eclass/mobile/apply'
      window.open(url, '_self')
      setTimeout(() => {
        location.reload()
      }, 1);
    } else {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.url = process.env.VUE_APP_URL_BEIKE + '/index.html#/apply/ekt-submit'
      window.addEventListener('message', (e) => {
        let data = e.data
        try {
          data = JSON.parse(data)
          this.$message[data.type](data.message)
        } catch (e) {
          console.debug(e.message)
        }
      })
    }
  },
}
</script>

<style scoped>
.apply-page {
  min-height: calc(100vh - 100px - 38px - 10px);
  padding-top: 100px;
  padding-bottom: 10px;
  background-color: #f5f5f5;
}
</style>